import React from 'react';
import { Table } from 'react-bootstrap';

export default function DatosPersonalesTable({ data }) {
  return (
    <div className="my-4" style={{ maxWidth: '95%', margin: '0 auto' }}>

      <h2
        className="mb-4"
        style={{
          textAlign: 'center',
          color: '#3C8DBC',
          fontWeight: 'bold',
        }}
      >
        Datos Personales
      </h2>

      <Table
        striped
        bordered
        hover
        responsive
        className="shadow-sm"
        style={{
          borderRadius: '8px',
          overflow: 'hidden',
          textAlign: 'center',
        }}
      >
        <thead style={{ backgroundColor: '#3C8DBC', color: '#fff' }}>
          <tr>
            <th>Nombre</th>
            <th>Apellido</th>
            <th>CUIL</th>
            <th>Sexo</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{data.nombre}</td>
            <td>{data.apellido}</td>
            <td>{data.nroCuil}</td>
            <td>{data.sexo}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
}
